(function($) {
  'use strict'

  var Career = {
    init: function() {
      if($(".news-career-form").length > 0) {
        this.initCareerNewsForm()
      }
      if($(".career-application-form").length > 0) {
        this.initCareerApplicationForm()
      }
    },

    // Register Career News Form
    initCareerNewsForm() {
      const $form = $('.news-career-form');

      if(!$form.length) return;

      // Validate form liên hệ
      $form.validate({
        rules: {
          name: {
            required: true,
            minlength: 2
          },
          email: {
            required: true,
            email: true
          },
          phone: {
            required: true,
            minlength: 10,
            maxlength: 11,
            number: true
          },
          message: {
            required: true,
            minlength: 10
          }
        },
        messages: {
          name: {
            required: "Vui lòng nhập họ tên",
            minlength: "Họ tên phải có ít nhất 2 ký tự"
          },
          email: {
            required: "Vui lòng nhập email",
            email: "Vui lòng nhập email hợp lệ"
          },
          phone: {
            required: "Vui lòng nhập số điện thoại",
            minlength: "Số điện thoại phải có ít nhất 10 số",
            maxlength: "Số điện thoại không được quá 11 số",
            number: "Vui lòng chỉ nhập số"
          },
          message: {
            required: "Vui lòng nhập nội dung tin nhắn",
            minlength: "Nội dung tin nhắn phải có ít nhất 10 ký tự"
          }
        },
        submitHandler: function(form) {
          const formData = new FormData(form);

          // TODO : CALL AJAX TO SUBMIT FORM HERE
          $.ajax({
            url: '#',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
              $form[0].reset();
            },
            error: function(xhr,status,error) {
              console.error('Error submitting form:',error);
            }
          });
        }
      });
    },

    // Init Career Application Form (viết gọn)
    initCareerApplicationForm: function() {
      const $form = $('.career-application-form');
      if(!$form.length) return;

      // Thêm validate file size
      $.validator.addMethod('filesize',function(v,e,p) {
        return this.optional(e) || (e.files[0].size <= p);
      });

      $form.validate({
        rules: {
          fullName: {required: true,minlength: 2},
          dob: {required: true},
          email: {required: true,email: true},
          address: {required: true},
          position: {required: true},
          department: {required: true},
          workUnit: {required: true},
          cvUpload: {
            required: true,
            extension: "jpg|png|odt|pdf|doc|docx|xls|xlsx|eml|msg",
            filesize: 5242880
          },
          'privacy-policy': {required: true}
        },
        messages: {
          fullName: {required: "Vui lòng nhập họ và tên",minlength: "Họ và tên phải có ít nhất 2 ký tự"},
          dob: {required: "Vui lòng nhập ngày sinh"},
          email: {required: "Vui lòng nhập email",email: "Vui lòng nhập email hợp lệ"},
          address: {required: "Vui lòng nhập địa chỉ"},
          position: {required: "Vui lòng nhập vị trí ứng tuyển"},
          department: {required: "Vui lòng chọn phòng ban"},
          workUnit: {required: "Vui lòng nhập đơn vị công tác"},
          cvUpload: {
            required: "Vui lòng tải lên CV",
            extension: "Vui lòng tải lên file có định dạng hợp lệ",
            filesize: "Kích thước file không được vượt quá 5MB"
          },
          'privacy-policy': {required: "Vui lòng đồng ý với chính sách bảo mật"}
        },
        submitHandler: function(form, event) {
          event.preventDefault();
          $.ajax({
            url: 'https://mockapi.io/api/v1/career-application',
            type: 'POST',
            data: new FormData(form),
            processData: false,
            contentType: false,
            success: function() {
              $form[0].reset();
              alert('Gửi đơn ứng tuyển thành công!');
            },
            error: function(_,__,error) {
              console.error('Error submitting form:',error);
              alert('Có lỗi xảy ra khi gửi đơn ứng tuyển. Vui lòng thử lại sau.');
            }
          });
        }
      });

      // Bổ sung: Revalidate các field khi onChange
      $form.find('input, select, textarea').on('change input', function() {
        // Nếu là file input thì chỉ validate khi có file
        if (this.type === 'file') {
          $form.validate().element(this);
        } else if (this.type === 'checkbox' || this.type === 'radio') {
          $form.validate().element(this);
        } else {
          $form.validate().element(this);
        }
      });

      // Xử lý drag & drop và hiển thị tên file
      var $fileInput = $('#cvUpload'),
        $fileLabel = $fileInput.closest('.file-upload').find('label');

      $fileLabel.on('drag dragstart dragend dragover dragenter dragleave drop',e => {e.preventDefault(); e.stopPropagation();});
      $fileLabel.on('dragover dragenter',() => $fileLabel.addClass('dragover'));
      $fileLabel.on('dragleave dragend drop',() => $fileLabel.removeClass('dragover'));
      $fileLabel.on('drop',e => {
        var files = e.originalEvent.dataTransfer.files;
        if(files && files.length) {
          $fileInput[0].files = files;
          $fileInput.trigger('change');
        }
      });

      $fileInput.on('change',function() {
        var file = this.files[0];
        if(file) {
          if(file.size > 5 * 1024 * 1024) {
            alert('Kích thước file không được vượt quá 5MB');
            $(this).val('');
            $fileLabel.html('TẢI LÊN CV <span class="plus">+</span>');
          } else {
            $fileLabel.text('Đã chọn: ' + file.name);
          }
        } else {
          $fileLabel.html('TẢI LÊN CV <span class="plus">+</span>');
        }
        // Revalidate file input khi thay đổi file
        $form.validate().element(this);
      });
    },
  }

  // Khởi chạy khi DOM ready
  $(function() {
    Career.init()
  })
})(jQuery)
